import React from "react";
import { FormBuilder, Validators } from "react-reactive-form";
import { useDispatch } from "react-redux";
import LoginSignUpBanner from "../../components/ReusableComponents/LoginSignUpBanner/LoginSignUpBanner";
import { ErrorUI } from "../../components/UI/Modals/Modals";
import { loginSignup } from "../../services/CallApi";
import { CheckIfSpecialCharacter } from "../../services/CommonFunction";
import { pattern } from "../../services/subscriberService";
import { profileActions } from "../../store";

const LoginSignUp = (WrappedComponent, headerDetail) => {
  return class extends React.Component {
    SignupForm = FormBuilder.group({
      email: ["", [Validators.required, Validators.pattern(pattern.username)]],
      password: [
        "",
        [
          Validators.required,
          Validators.minLength(10),
          CheckIfSpecialCharacter,
        ],
      ],
    });

    handleSubmit = (e) => {
      e.preventDefault();
      if (this.SignupForm.valid) {
        loginSignup(this.SignupForm.value, headerDetail.status).then(
          (response) => {
            if (response.status) {
              // this.props.updateProfileData(response.data);
              this.navigate("inside");
            } else {
              ErrorUI(response.list);
            }
          }
        );
      }
    };

    navigate = (navigateType) => {
      switch (true) {
        case navigateType === "SignUp":
          return this.props.history.push({ pathname: "/SignUp" });
        case navigateType === "SignIn":
          return this.props.history.push({ pathname: "/SignIn" });
        case navigateType === "ForgotPassword":
          return this.props.history.push({ pathname: "/ForgotPassword" });
        case navigateType === "inside":
          return this.props.history.push({ pathname: "/" });
        case navigateType === "SignUpSteps":
          return this.props.history.push({ pathname: "/SignUpSteps" });
        default:
          return this.props.history.push({ pathname: "/SignIn" });
      }
    };

    render() {
      return (
        <LoginSignUpBanner {...headerDetail}>
          <WrappedComponent
            navigate={this.navigate}
            SignupForm={this.SignupForm}
            handleSubmit={this.handleSubmit}
            {...this.props}
          />
        </LoginSignUpBanner>
      );
    }
  };
};

export default LoginSignUp;
